import { resolveUri, resolveQueryString, } from '@move-frontend/utils';
import { AbstractService } from './AbstractService';
import { CLIENT_VERSION } from '../versions';
export class WeatherService extends AbstractService {
    /**
     * Request weather information.
     * @param iata
     * @param params Get parameters
     * @param requestConfig Config options for axios
     */
    get(iata, params = {}, requestConfig = {}) {
        const uri = `${resolveUri(WeatherService.URI_PATH, {
            iata,
        })}${resolveQueryString(params)}`;
        const defaultConfig = {
            method: 'GET',
            headers: { 'Api-Version': WeatherService.VERSION },
        };
        return this.client.request(uri, Object.assign(Object.assign({}, defaultConfig), requestConfig));
    }
}
/**
 * Path of the resource to be used by the service.
 */
Object.defineProperty(WeatherService, "URI_PATH", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 'weather/:iata'
});
/**
 * Client version necessary for the service.
 */
Object.defineProperty(WeatherService, "VERSION", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: CLIENT_VERSION
});
//# sourceMappingURL=WeatherService.js.map